(function () {
    var $form = $('#search-form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['select[name="country"]', 'presence', gmtrans('booking.frontend_validation.country_required')],
        ['select[name="location"]', 'presence', gmtrans('booking.frontend_validation.location_required')],
        ['input[name="start_date"]', 'presence', gmtrans('booking.frontend_validation.start_date_required')],
        ['input[name="start_time"]', 'presence', gmtrans('booking.frontend_validation.start_time_required')],
        ['input[name="end_date"]', 'presence', gmtrans('booking.frontend_validation.end_date_required')],
        ['input[name="end_time"]', 'presence', gmtrans('booking.frontend_validation.end_time_required')],
        ['input[name="age"]', 'presence', gmtrans('booking.frontend_validation.age_required')],
        ['input[name="passengers"]', 'presence', gmtrans('booking.frontend_validation.passengers_required')],
        ['select[name="vehicle_type"]', 'presence', gmtrans('booking.frontend_validation.vehicle_type_required')],
    ];

    setTimeout(function () {
        $form.nod(metrics, options);
    }, 1000);
})();
